import React, { useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import { post } from "../../../services/api";
import { dateFormat } from "../../../utils/date";
const EmailLog = ({token, emailList}) => {


  

  const [emails, setEmails] = useState([]);
  useEffect(()=>{
    if(emailList?.length > 0) {
      getEmails(emailList)
    }
  },[emailList])

  const getEmails = async (emailList) => {
    try {
      const response = await post("/api/email-log/email-check", {
        emails: emailList,
      },token);
      if (response?.data) {
        setEmails(
          response?.data?.map((e) => {
            return {
              date: dateFormat(e.sentDateTime),
              action: emailList.includes(e.senderEmail)
                ? "Email Sent"
                : "Email Received",
              subject: e.subject,
              contact: emailList.includes(e.senderEmail)
                ? e.senderName
                : e.fromName,
              emailBody: e?.body?.content,
            };
          })
        );
      }
    } catch (e) {
      console.log("error", e);
    }
  };


  return (
    <Table bordered hover responsive>
      <thead style={{ backgroundColor: "#f4f4f4" }}>
        <tr>
          <th>Date</th>
          <th>Action</th>
          <th>Subject</th>
          <th>Contact</th>
        </tr>
      </thead>
      <tbody>
        {emails.map((email, index) => (
          <React.Fragment key={index}>
            {/* First row with main details */}
            <tr style={{ height: "70px" }}>
              <td>{email.date}</td>
              <td>{email.action}</td>
              <td>{email.subject}</td>
              <td>{email.contact}</td>
            </tr>
            {/* Second row with the email body */}
            <tr style={{ height: "100px", backgroundColor: "#f9f9f9" }}>
              <td colSpan="4" style={{ padding: "20px" }}>
              <div
                  dangerouslySetInnerHTML={{ __html: email.emailBody }}
              ></div>
                
              </td>
            </tr>
          </React.Fragment>
        ))}
      </tbody>
    </Table>
  );
};


export default EmailLog;
